import { useState, useEffect, useRef } from "react";
import CarritoCompras from "../components/CarritoCompras";
import { useProductos } from "../hooks/useProductos";
import Header from "../components/layout/Header";
import presentation2 from "../assets/presentation2.mp4";
import presentation from "../assets/presentation.mp4";
import cart from "../assets/cart.png";

import Whatsapp from "../assets/Whatsapp.svg"
import SlideTwo from "../components/SlideTwo";
import portada from "../assets/portada.png";
import iconoItalia from "../assets/icon-italia.png";
import iconoEnviosNacionales1 from "../assets/icono-envios-nacionales-1.png";
import iconoEnviosRapidos1 from "../assets/icono-envios-rapidos-1.png";
import Footer from "../components/layout/Footer";
import SlideHome from "../components/SlideHome";
import { Link } from "react-router-dom";
import { routes } from "../helpers/Routes";
import SliderClientes from "../components/SliderClientes";
import { useLocation } from "react-router-dom";
import CardBike from "../components/CardBike";
import Promotion from '../components/Promotion/Promotion'
// Import Swiper styles
import { API } from '../components/FormEdit'
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
// import required modules
import { Helmet } from "react-helmet-async";
const Home = () => {
    const { productos, formatoCOP } = useProductos();
    const [openCart, setOpenCart] = useState(false);
    const [homeProducts, setHomeProducts] = useState([])
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    useEffect(() => {
        fetch(`${API}/api/slider`)
            .then(data => data.json())
            .then(data => setHomeProducts(data.products))
    }, []);




    return (
        <>
            <Helmet prioritizeSeoTags={true}>
                <title>Bicletas Java Colombia</title>
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Bicicletas java colombia" />
                <meta property="og:url" content="https://bicicletasjavacolombia.com/" />
                <meta property="og:image" content="https://bicicletasjavacolombia.com/src/assets/logo-footer.png" />
                <meta property="og:description" content="Directo desde Italia Tenemos lo mejorpara los mejores en alto rendimiento Las bicicletas JAVA son más que solo máquinas de pedalear; representan una tradición de calidad, innovación y pasión por el ciclismo. Desde su humilde inicio hasta su prominencia en la industria, la historia de las bicicletas JAVA es una historia inspiradora de determinación y excelencia en el mundo del ciclismo. Sostenibilidad y el respeto por el medio ambiente Calidad y diseño con meticulosidad y cuidado para crear modelos únicos y atractivos Los diseñadores se inspiran en la naturaleza y el arte Nuestro Stock All Bicicletas de Montaña Bicicletas de Ruta Bicicleta de Ruta JAVA Siluro 6 Top Up Bicicleta de Ruta JAVA Fuoco Top Bicicleta de Ruta JAVA Siluro 6 Top Bicicleta MTB JAVA DOLOMIA 24S Bicicleta de Ruta JAVA SILURO 3D SUOH El diseño de las bicicletas Java es otro elemento distintivo. Los diseñadores se inspiran en la naturaleza y el arte para crear modelos únicos y atractivos. Cada bicicleta está cuidadosamente elaborada para ofrecer un equilibrio perfecto entre estilo y funcionalidad, brindando una experiencia de conducción excepcional. Realizamos entregas de tu bici a todo el territorio nacional Tenemos los estandares de calidad mas altos en cuanto a envíos seguros y rápidos Silurio TOP 6 colmo de manera satisfactoria mis expectativas. Rode mis primeros 42 kms adaptándome a está maravillosa máquina. En cuanto al cumplimiento en tiempos desde compra a entrega, excelente. Desde Ipiales Nariño un saludo Willian NietoNariño JAVA Siluro Top 6!!! Excelente maquina desde la primera rodada hasta ahora más de 500kms sin ningún problema. Muy ágil y compacta. Ricardo CastilloBogotá La cicla excelente cumplió con las expectativas,valió la pena de haber esperado para que llegara Jorge Alberto Zapata VázquezCartagena Día de rodada con mi esposita, con nuestras bicis java, excelentes bicis, gracias java colombia Oscar Alexander Guevara MuñozBogotá Previous Next" />
            </Helmet>
            <div style={{ maxWidth: "100%", width: "100%", backgroundColor: "#000000", color: "#fff" }}>
                <Header setOpenCart={setOpenCart} openCart={openCart} />
                <CarritoCompras setOpenCart={setOpenCart} openCart={openCart} />
                <div className="banner">
                    <video autoPlay muted loop>
                        <source src={presentation2} type="video/mp4" />
                        Tu navegador no soporta la reproducción de videos.
                    </video>
                    <div className="welcome-message">
                        <h1>Siente la velocidad, domina el camino</h1>
                    </div>
                </div>

                <div className="wrapper">
                    <Promotion bike={homeProducts?.find(ho => ho.assign == "promo")}></Promotion>
                </div>
                
                <div className="about-section">
                    <div className="about-content">
                        <h1 className="section-about-h1">Diseño Italiano</h1>
                        <p>Diseño extraordinario, que garantiza alto rendimiento.</p>
                        <p style={{ fontSize: 15 }}>
                            Las bicicletas JAVA son más que solo máquinas de pedalear; representan una tradición de calidad, innovación y pasión por el ciclismo. Desde su inicio, la historia de las bicicletas JAVA es inspiradora, llena de determinación y excelencia en el mundo del ciclismo.
                        </p>
                    </div>
                    <div className="features-box">
                        {/* <p>Calidad y diseño con meticulosidad y cuidado para crear modelos únicos y atractivos</p>
                    <p>Sostenibilidad y el respeto por el medio ambiente</p>
                    <p>Los diseñadores se inspiran en la naturaleza y el arte</p> */}
                        <video autoPlay muted loop className="video-features">
                            <source src={presentation} type="video/mp4" />
                            Tu navegador no soporta la reproducción de videos.
                        </video>
                    </div>

                </div>

                <SlideHome homeProducts={homeProducts} />


                <div className="wrapper" style={{ margin: "100px auto 100px auto", overflow: "hidden" }}>
                    <p style={{ textAlign: "center", fontSize: 58 }}>Nuestro Stock</p>

                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>

                        <div className="products-bike-container-grid">

                            {productos?.map((producto, index) => {
                                console.log(index)
                                return (
                                    <CardBike key={index} producto={producto} formatoCOP={formatoCOP}></CardBike>
                                )
                            })}
                        </div>

                    </div>

                </div>
                <div className="wrapper">

                    <SlideTwo></SlideTwo>
                </div>


                <div className="wrapper">
                    <div className="portada" style={{ backgroundImage: `url(${portada})` }}>
                        <div className="card-portada ">
                            <img src={iconoItalia} alt="Diseño italiano" />
                            <p>
                                El diseño de las bicicletas Java es otro elemento distintivo. Los diseñadores se inspiran en la naturaleza y el arte para crear modelos únicos y atractivos. Cada bicicleta está cuidadosamente elaborada para ofrecer un equilibrio perfecto entre estilo y funcionalidad, brindando una experiencia de conducción excepcional.
                            </p>
                        </div>
                        <div className="card-portada ">
                            <img src={iconoEnviosNacionales1} alt="Entregas nacionales" />
                            <p>Realizamos entregas de tu bici a todo el territorio nacional</p>
                        </div>
                        <div className="card-portada ">
                            <img src={iconoEnviosRapidos1} alt="Altos estándares de calidad" />
                            <p>Tenemos los estándares de calidad más altos en cuanto a envíos seguros y rápidos</p>
                        </div>
                    </div>
                </div>

                <SliderClientes />

                <div className="wrapper" >
                    <div className="boton-contacto-container" style={{ width: "100%", display: "flex", justifyContent: "flex-end", margin: "20px 0" }}>
                        <Link to={routes.contacto} className="boton-contacto">Contáctanos</Link >
                    </div>
                </div>
                <Footer />
                <a onClick={() => setOpenCart(true)} className="float  carrito-button" target="_blank">
                    <img src={cart} width={24} />
                </a>
                <a href="https://api.whatsapp.com/send/?phone=573107336975&text=Hola, me gustaria obtener más información acerca de los productos&type=phone_number&app_absent=0" className="float-carrito " target="_blank">
                    <img src={Whatsapp} width={24} />
                </a>
            </div>
        </>
    );
};

export default Home;
